import { IdCodeNamePair } from '../../redux/common/definitions';
import { apiBaseUrl, apiCall } from '../api';

const baseURL = apiBaseUrl;

type StateTypes = 'entity' | 'scholarship' | 'project' | 'invoice';

export const getStatesByTypeFromApi = async (type: StateTypes): Promise<IdCodeNamePair[]> => {
  const init = {
    method: 'GET',
    auth: true,
  };
  const { data } = await apiCall<{ data: IdCodeNamePair[] }>(`${baseURL}/states/type/${type}`, init);
  return data;
};
